import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService, UserService } from '@base/shared/services';
import { get } from 'lodash'

@Component({
  selector: 'eyrus-completed-teammate-invitation',
  templateUrl: './completed-teammate-invitation.component.html',
  styleUrls: ['./completed-teammate-invitation.component.sass']
})
export class CompletedTeammateInvitationComponent implements OnInit {

  data: Array<any> = JSON.parse(localStorage.getItem('eyrus-members-invited') || '[]') || [];
  type: String = 'project';
  title: String = '';
  created: Boolean = false;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private navigation: NavigationService,
    private accountService: UserService

  ) { }

  ngOnInit() {
  }

  confirm() {
    this.cleanData(); 
    this.activeModal.close(true);
  }

  close() {
    this.cleanData();

    this.activeModal.close(false);
  }

  get getTitle() {
    return this.type === 'contract' ? get(this.accountService, 'account.contract.company.companyName') : this.title;
  }

  goToMembers() {
    this.confirm();
  }

  goToCreateContract() {
    this.cleanData();
    this.activeModal.close('create-contract');
  }
  goToDailyLogs() {
    this.cleanData();
    this.activeModal.close('daily-logs');
  }
  goToProjectSettings() {
    this.cleanData();
    this.activeModal.close('settings');
  }

  private cleanData() {
    localStorage.removeItem('eyrus-members-invited');
    localStorage.removeItem('eyrus-item-created');
  }
}
